import React from 'react';

const TermsAndConditions = () => {
  const effectiveDate = "Jan, 2026";

  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>Terms and Conditions</h1>
        
        <p className="effective-date">Effective Date: {effectiveDate}</p>

        <p><strong>Legal Entity:</strong> DonatePe is a crowdfunding platform owned and operated by Lord Welfare Organisation, a registered entity in India.</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using the DonatePe website/app, operated and owned by Lord Welfare Organisation ("NGO"), you agree to be bound by these Terms and Conditions. DonatePe is a brand/platform of Lord Welfare Organisation. If you do not agree, please refrain from using our services.</p>
        </section>

        <section>
          <h2>2. Eligibility</h2>
          <p><strong>Individuals:</strong> You must be at least 18 years of age and a resident of India to create a campaign or make a donation.</p>
          <p><strong>Entities:</strong> NGOs, trusts, or companies must be legally registered in India and provide valid registration documents (e.g., 12A/80G certificates) where applicable.</p>
        </section>

        <section>
          <h2>3. Campaigner Responsibilities</h2>
          <p>As a campaigner on DonatePe, you represent and warrant that:</p>
          <p><strong>Authenticity:</strong> All information provided regarding the cause, medical reports, or financial need is 100% accurate and truthful.</p>
          <p><strong>Fund Usage:</strong> Funds raised will be used exclusively for the stated purpose. Any diversion of funds is a breach of trust and may lead to legal action.</p>
          <p><strong>Updates:</strong> You agree to provide regular updates to donors regarding the progress of the campaign.</p>
        </section>

        <section>
          <h2>4. Donor Terms</h2>
          <p><strong>Voluntary Contribution:</strong> Donations are made voluntarily. DonatePe does not guarantee that a campaign will reach its goal.</p>
          <p><strong>No Financial Return:</strong> Donors understand that crowdfunding on DonatePe is a gift/donation. You will not receive equity, interest, or any financial return.</p>
          <p><strong>Tax Benefits:</strong> 80G tax-exempt receipts are issued only by registered NGOs. DonatePe is a platform and does not personally provide tax benefits unless the specific campaign is 80G-eligible.</p>
        </section>

        <section>
          <h2>5. Fees and Payments</h2>
          <p><strong>Platform Fee:</strong> DonatePe may charge a platform fee (e.g., 0% to 5%) plus applicable GST for providing crowdfunding services.</p>
          <p><strong>Third-Party Charges:</strong> Payment gateway charges (for UPI, Credit Card, Net Banking) are deducted before the final amount is disbursed to the campaigner.</p>
          <p><strong>Disbursement:</strong> Funds are typically disbursed within 3 working days after a withdrawal request, subject to verification.</p>
        </section>

        <section>
          <h2>6. Refund and Cancellation Policy</h2>
          <p><strong>General Rule:</strong> Donations are generally non-refundable once the funds have been disbursed to the campaigner.</p>
          <p><strong>Fraudulent Campaigns:</strong> If a campaign is proven to be fraudulent before disbursement, DonatePe will initiate a refund to all donors within 7-10 working days.</p>
        </section>

        <section>
          <h2>7. Prohibited Activities</h2>
          <p>Users are strictly prohibited from:</p>
          <p>Posting campaigns for illegal activities or prohibited items under Indian law.</p>
          <p>Using the platform for money laundering or "hawala" transactions.</p>
          <p>Providing false KYC documents (Aadhaar/PAN).</p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>DonatePe acts as an intermediary (as defined under the IT Act, 2000). We do not endorse any campaign and are not responsible for the misuse of funds by campaigners. We perform "reasonable due diligence," but the final responsibility lies with the donor to verify the cause.</p>
        </section>

        <section>
          <h2>9. Governing Law</h2>
          <p>These terms are governed by the laws of India.</p>
        </section>

      
      </div>

      <style jsx>{`
        .terms-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 2rem 1.5rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          line-height: 1.6;
          color: #3a3a3a;
        }

        .terms-content {
          background: #ffffff;
        }

        h1 {
          font-size: 2.2rem;
          font-weight: 600;
          color: #212121;
          margin-bottom: 0.5rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid #e0e0e0;
        }

        .effective-date {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 1.5rem;
        }

        h2 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #212121;
          margin: 2rem 0 1rem 0;
          padding-bottom: 0.3rem;
          border-bottom: 1px solid #f0f0f0;
        }

        p {
          margin-bottom: 1rem;
          text-align: left;
        }

        strong {
          color: #212121;
          font-weight: 600;
        }

        a {
          color: #e67e22;
          text-decoration: none;
        }

        a:hover {
          text-decoration: underline;
        }

        section {
          margin-bottom: 1rem;
        }

        .footer-links {
          margin-top: 3rem;
          padding-top: 1.5rem;
          border-top: 1px solid #e0e0e0;
          text-align: left;
        }

        .footer-links a {
          color: #e67e22;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .terms-container {
            padding: 1.5rem 1rem;
          }
          h1 {
            font-size: 1.8rem;
          }
          h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsAndConditions;